<div nz-row>
  <div nz-col>
    @if (!isPhonePortrait) {
    <img nz-image nzSrc="/public/assets/images/login-img.png" alt="" class="full-img-height login-fixed-image" />
    }
  </div>
  <div class="login-container" nz-col [nzXs]="24" [nzLg]="24">
    <form nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
      <h2 nz-typography>{{ 'login.title' | translate }}</h2>
      <p nz-typography style="margin-bottom: 3em">{{ 'login.subtitle' | translate }}</p>
      @if(disabledMFA){
      <nz-form-item>
        <nz-form-control nzErrorTip="{{ 'login.invalidEmail' | translate }}">
          <nz-form-label [nzSpan]="6" nzFor="email">{{ 'login.username' | translate }}</nz-form-label>
          <nz-input-group>
            <input type="text" nz-input nzSize="large" formControlName="email"
              placeholder=" {{ 'login.writeEmail' | translate }}" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control nzErrorTip="{{ 'login.invalidPassword' | translate }}">
          <nz-form-label [nzSpan]="6" nzFor="password">{{ 'login.password' | translate }}</nz-form-label>
          <div>
            <nz-input-group [nzSuffix]="suffixTemplate">
              <input [type]="passwordVisible ? 'text' : 'password'" nz-input
                placeholder="{{ 'login.writePassword' | translate }}" nzSize="large" formControlName="password" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <span nz-icon class="ant-input-password-icon" [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"></span>
            </ng-template>
          </div>
        </nz-form-control>
      </nz-form-item>

      <div nz-row class="login-form-margin">
        <div nz-col [nzSpan]="24">
          <a class="login-form-forgot" role="button" tabindex="0" (click)="checkEmail()" (keydown.enter)="checkEmail()" (keydown.space)="checkEmail(); $event.preventDefault()"><u><strong>{{ 'login.forgotPassword' | translate
                }}</strong></u></a>
        </div>
      </div>
      }
      <ds-button [text]="'buttons.login' | translate" [width]="'medium'" [styleType]="'default-main'" class="theme-color text-uppercase login-form-button" ariaLabel="Accedi al tuo account"></ds-button>
      @if(!disabledMFA){
      <div nz-row class="login-form-margin-dis">
        <div nz-col [nzSpan]="24">
          <a class="login-form-forgot" role="button" tabindex="0" (click)="goToForgotPassword()" (keydown.enter)="goToForgotPassword()" (keydown.space)="goToForgotPassword(); $event.preventDefault()">
            <u><strong>{{ 'login.forgotPassword' | translate }}</strong></u></a>
        </div>
      </div>
      }
      @if (showGoogleLoginButton && !isOnMobile) {
      <nz-divider nzText="{{ 'login.or' | translate }}" style="color: grey"></nz-divider>
      <ds-button [text]="'login.logInWithGoogle' | translate" [width]="'medium'" [styleType]="'empty-main'" class="text-uppercase login-form-button" id="google-login-btn" ariaLabel="Accedi con Google" (click)="initializeGoogle(); $event.preventDefault()"></ds-button>
      }

      <!-- <div>
          <div class="inner-box">
            <button nz-button nzType="primary" nzShape="round" nzSize="large" class="text-uppercase" style="font-size: 14px" (click)="openFacebookLogin()">
              <span nz-icon nzType="facebook" nzTheme="outline"></span>
              {{ 'login.logInWithFacebook' | translate }}
            </button>
          </div>
        </div> -->
    </form>
  </div>

  <!-- <div nz-row nzAlign="bottom" nzJustify="center" style="width: -webkit-fill-available">
                <div nz-col>
                  {{ 'login.moreInfo' | translate }}
                  <a class="termsAndConditions"
                    ><u
                      ><strong>{{ 'login.useCondition' | translate }}</strong></u
                    ></a
                  >
                  {{ 'login.and' | translate }}
                  <a class="termsAndConditions"
                    ><u
                      ><strong>{{ 'login.dataTraitments' | translate }}</strong></u
                    ></a
                  >
                </div>
              </div> -->
</div>